<template>
  <div class="container">
    <MenuTeacher />
    <div class="teacher-container">
      <a-layout>
        <a-layout-sider>
          <SideMenuTeacher />
        </a-layout-sider>
        <a-layout-content>
          <a-card :bordered="false">
            <router-view />
          </a-card>
        </a-layout-content>
      </a-layout>
    </div>
    <!-- <Footer /> -->
  </div>
</template>

<script>
import MenuTeacher from "../components/MenuTeacher";
import SideMenuTeacher from "../components/SideMenuTeacher";
import Footer from "../components/Footer";
export default {
  name: "MenuLayout",
  components: {
    MenuTeacher,
    Footer,
    SideMenuTeacher
  },
  data() {
    return {};
  },
  methods: {
    handleClick(e) {
      console.log("click ", e);
    },
  },
};
</script>

<style scoped>
.container {
  background: url(~@assets/theme/xmw/student-bg.png)  #fafcfc;
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
}
.teacher-container {
  width: 1500px;
  margin: 10px auto;
}
.ant-layout {
  background: transparent;
}
.ant-layout-sider {
  background: #fff;
  text-align: center;
}
.ant-card {
  margin: 0 20px;
}
</style>